import { Badge, IconButton } from "@mui/material"
import { format } from "date-fns"
import i18n from "i18n-js"
import { useMemo } from "react"
import { Icons } from "../../../../../utils"
export const useColumns = ({ onOpenGallery } = {}) => {
    const columns = useMemo(() => {
        const list = [
            {
                field: 'created_at',
                headerName: i18n.t('observation.createdDate'),
                flex: 1,
                sortable: true,
                renderCell: (params) => (
                    <span
                        style={{
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                            overflow: 'visible',
                        }}
                    >
                        {params?.value
                            ? format(new Date(params?.value), i18n.t('general.dateTimeFormat'))
                            : i18n.t('general.dataNotFound')}
                    </span>
                ),
            },
            {
                field: 'observation_type',
                headerName: i18n.t('observation.observationType'),
                flex: 1,
                sortable: true,
            },
            {
                field: 'medical_staff',
                headerName: i18n.t('observation.creator'),
                flex: 1,
                sortable: true,
                renderCell: (params) => {
                    return (
                        <span
                            style={{
                                whiteSpace: 'normal',
                                wordBreak: 'break-word',
                                overflow: 'visible',
                            }}
                        >
                            {`${params?.value?.name} ${params?.value?.lastname}`}
                        </span>
                    )
                },
            },
            {
                field: 'name',
                headerName: i18n.t('observation.comment'),
                flex: 2,
                sortable: true,
                renderCell: (params) => (
                    <span
                        style={{
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                            overflow: 'visible',
                        }}
                    >
                        {params.value ?? ""}
                    </span>
                ),
            },
            {
                field: 'photos',
                headerName: i18n.t('observation.photos.count'),
                width: 90,
                sortable: false,
                align: 'center',
                headerAlign: 'center',
                renderCell: ({ row }) => {
                    const count = row.photos?.length || 0
                    if (!count) return null
                    return (
                        <IconButton size="small" onClick={() => onOpenGallery(row)}>
                            <Badge badgeContent={count} color="secondary">
                                {Icons('camera')}
                            </Badge>
                        </IconButton>
                    )
                },
            },
        ]
        return list
    }, [onOpenGallery])

    return {
        column: columns
    }
}